import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { getHelpCenterQuestionList } from "../../../../services/workspace/helpCenterQuestion.service";
import { convertToLabelValue } from "../../../../utils/common";

const HelpCenterSearch = () => {
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [pre_value] = useState([]);
  const [tempOptions, setTempOptions] = useState([]);
  const [searchLoading, setSearchLoading] = useState(true);
  const debounceTimeoutRef = useRef(null); // Store timeout reference
  const fetchData = async (search = "") => {
    try {
      const params = {
        search: search,
      };
      return await getHelpCenterQuestionList(params);
    } catch (error) {
      return [];
    }
  };

  const loadOptions = async (inputValue) => {
    if (!inputValue) {
      return tempOptions;
    }
    // Clear previous timeout to ensure only the latest search triggers the API call
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    // Set a new timeout to call fetchData after the specified delay
    return new Promise((resolve, reject) => {
      debounceTimeoutRef.current = setTimeout(async () => {
        try {
          const result = await fetchData(inputValue);

          if (result && result?.data) {
            setTempOptions(convertToLabelValue(result.data, true));
            setSearchLoading(false);
            resolve(convertToLabelValue(result.data, true)); // Return converted data
          } else {
            resolve([]); // Return an empty array if no data
          }
        } catch (error) {
          reject(error); // Reject if error occurs during API call
        }
      }, 500); // 500ms debounce delay
    });
  };
  const handleInputChange = (inputValue) => {
    setTempOptions([]);
    if (inputValue) {
      setSearchLoading(true);
      loadOptions(inputValue); // Fetch options based on input value
    }
  };

  const handleOnChange = (value) => {
    navigate(`/help/question/detail/${value.uuid}`);
  };
  useEffect(() => {
    if (pre_value && pre_value.length) {
      setOptions([...pre_value]);
    }
  }, [pre_value]);

  return (
    <div className="bg-light rounded-md flex flex-col gap-2 items-center px-10  justify-center min-h-36 w-full">
      <h2 className="font-bold text-md">Welcome To School Help Centre</h2>
      <Select
        options={tempOptions}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            fontSize: "12px",
            zIndex: 9999,
          }),
        }}
        isLoading={searchLoading} // Display loading indicator
        placeholder="Search Question"
        value={[]}
        onInputChange={handleInputChange} // Fetch new options on input change
        closeMenuOnSelect={false}
        onChange={handleOnChange}
        className="help-center react-select-container text-sm w-full max-w-[380px] bg-light border"
        classNamePrefix="react-select"
      />
    </div>
  );
};

export default HelpCenterSearch;
